import React, { Component } from 'react';
import { AppBar, Toolbar, Hidden, IconButton, Icon, Typography, Menu, MenuItem, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authService from '../../api/authService';
import { decodeTokenJsonUser } from '../helpers/jwtDecoder';
import { logout } from '../../redux/actions/authActions';

class TopBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuProfileAnchor: null
        }
        this.setAnchor = this.setAnchor.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.logout = this.logout.bind(this);
    }

    setAnchor(evt) {
        this.setState({
            menuProfileAnchor: evt.currentTarget
        });
    }

    closeMenu() {
        this.setState({
            menuProfileAnchor: null
        });
    }

    logout() {
        authService.logout();
        this.setState({
            menuProfileAnchor: null
        });
    }

    render() {
        const { toggleDrawer } = this.props;
        const { menuProfileAnchor } = this.state;
        const { unique_name, role } = this.props.user;
        return (
            <AppBar position="fixed" style={{ flexGrow: 1 }}>
                <Toolbar>
                    <Hidden only={['xl', 'md', 'lg']}>
                        <IconButton edge="start"
                            color="inherit"
                            onClick={toggleDrawer}
                            style={{ marginRight: 25 }}>
                            <Icon>menu</Icon>
                        </IconButton>
                        <Typography variant="h6" >InstaJob</Typography>
                    </Hidden>
                    <div style={{ flexGrow: 1, textAlign: 'right' }}>
                        <Button variant="text"
                            aria-label="Account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={this.setAnchor}
                            color="inherit">
                            <Icon style={{ marginRight: 15 }}>{role === 'COMPANY' ? 'store' : 'account_circle'}</Icon>
                            {unique_name}
                        </Button>
                        <Menu
                            id="menu-appbar"
                            anchorEl={menuProfileAnchor}
                            keepMounted
                            open={Boolean(menuProfileAnchor)}
                            onClose={this.closeMenu}
                            style={{ marginTop: 30 }}>
                            <MenuItem onClick={this.logout}>Logout</MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = ({ authState }) => ({
    user: decodeTokenJsonUser(authState.loggedUser)
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ logout }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);